import { defineComponent as _defineComponent } from 'vue'
import { CdnImg } from '@webplatform/cdn-image';

// TODO: fix type
interface Props {
  product: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'DriversCard',
  props: {
    product: null
  },
  setup(__props: any) {



return { __sfc: true,CdnImg }
}

})